import React from "react";

import "./index.scss";
import { Link } from "react-router-dom";

const items = [
  { path: "", name: "HOME" },
  { path: "spanish", name: "ESP" },
  { path: "japanese", name: "JPN" },
  { path: "korean", name: "KOR" },
];

const Navigation = ({ theme }) => {
  return (
    <nav className={`navigation${theme === "light" ? " light-theme" : ""}`}>
      <ul>
        {items.map((item = {}, i) => (
          <li key={`${item.path}_${i}`}>
            <Link
              className={`nav-link${
                item.path && window.location.pathname.includes(item.path)
                  ? " active-link"
                  : ""
              }`}
              to={`/${item.path}`}
            >
              <span>{item.name}</span>
              <span className="dot"></span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
